import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { UserProvider, useUserContext } from "./Context/UserContext";
import {
  LoaderProvider,
  ToastProvider,
  useLoaderContext,
  useToastContext,
} from "./Context/ToastContext";
import Navbar from "./Components/CommonComponent/Navbar/Navbar";
import LoginPage from "./Components/CommonComponent/Forms/LoginPage/LoginPage";
import Toast from "./Components/CommonComponent/Toast/Toast";
import UpdatePassword from "./Components/CommonComponent/Forms/UpdatePassword/UpdatePassword";
import PrivateRoutes from "./Routes/PrivateRoutes";
import Loader from "./Components/CommonComponent/Loader/Loader";
import ConfirmationPopup from "./Components/CommonComponent/ConfirmationPopup/ConfirmationPopup";
import NotFound from "./Components/CommonComponent/NotFound/NotFound";

const App = () => {
  return (
    <Router>
      <UserProvider>
        <ToastProvider>
          <LoaderProvider>
            <MainApp />
          </LoaderProvider>
        </ToastProvider>
      </UserProvider>
    </Router>
  );
};

const MainApp = () => {
  const location = useLocation();
  const { userRole } = useUserContext();
  const { toastState, hideToast } = useToastContext();
  const { open: toastOpen, message: toastMessage, severity: toastSeverity } = toastState;
  const { loading } = useLoaderContext();

  // Hide navbar on login and updatePassword pages
  const hideNavbar = ["/login", "/updatePassword"].includes(location.pathname);

  return (
    <>
      {!hideNavbar && <Navbar />}
      {loading && <Loader />}
      <Routes>
        <Route path="/*" element={userRole() ? <PrivateRoutes /> : <Navigate to="/login" />} />
        <Route path="/login" element={userRole() ? <Navigate to="/" /> : <LoginPage />} />
        <Route
          path="/updatePassword"
          element={userRole() ? <Navigate to="/" /> : <UpdatePassword />}
        />
        <Route path="*" element={<NotFound/>} />

      </Routes>
      <Toast open={toastOpen} message={toastMessage} severity={toastSeverity} onClose={hideToast} />
      <ConfirmationPopup />
    </>
  );
};

export default App;
